import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import useAccountTypes from '../../../queries/useAccountTypes';
import StyledMenu from '../../common/StyledMenu/StyledMenu';
import Toolbar from '../../common/Toolbar/Toolbar';
import AccountsTable from '../tables/AccountsTable/AccountsTable';
import styles from './AccountsBlock.module.scss';

const AccountsBlock = ({ accounts = [] }) => {
  const [menu, setMenu] = useState([{ id: 'all', name: 'Все счета' }]);
  const [currentKey, setCurrentKey] = useState('all');

  const { data: accountTypes, isFetching: isAccountTypesFetching } =
    useAccountTypes({ staleTime: Infinity });

  useEffect(() => {
    if (accountTypes?.length) {
      const updateMenu = (prev) => prev.concat(accountTypes);
      setMenu(updateMenu);
    }
  }, [accountTypes]);

  const handleMenuItemClick = ({ key }) => {
    setCurrentKey(key);
  };

  const currentAccounts =
    currentKey === 'all'
      ? accounts
      : accounts.filter((account) => account.type.id === Number(currentKey));

  return (
    <div className={styles.root}>
      <Toolbar background="dark">
        <Spin spinning={isAccountTypesFetching}>
          <StyledMenu
            onClick={handleMenuItemClick}
            itemKeyName="id"
            itemContentName="name"
            items={menu}
            selectedKeys={[currentKey]}
          />
        </Spin>
      </Toolbar>
      <AccountsTable accounts={currentAccounts} />
    </div>
  );
};

export default AccountsBlock;
